import React, { Fragment, Suspense, useContext, useEffect, useMemo } from 'react';
import NProgress from 'nprogress';
import { Route, Switch } from 'react-router-dom';

// material
import { makeStyles } from '@material-ui/core/styles';
// guards
// components
import LoadingScreen from '../components/LoadingScreen';
// import the brand context provider
//

import { ProfileContext } from '../contexts/ProfileContext';
import { BrandContext } from '../contexts/BrandContext';
import { CommonRoutes, getFPCoRoutes, getRootAdminRoutes, getSchoolRoutes, getTravelCoRoutes, UnauthenticatedRoutes } from './dashboard.routes';
import AuthGuard from "../guards/AuthGuard";
import DashboardLayout from '../layouts/dashboard';
import { SelectorContext } from '../contexts/SelectorContext';



// ----------------------------------------------------------------------

const nprogressStyle = makeStyles((theme) => ({
  '@global': {
    '#nprogress': {
      pointerEvents: 'none',
      '& .bar': {
        top: 0,
        left: 0,
        height: 2,
        width: '100%',
        position: 'fixed',
        zIndex: theme.zIndex.snackbar,
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 0 2px ${theme.palette.primary.main}`
      },
      '& .peg': {
        right: 0,
        opacity: 1,
        width: 100,
        height: '100%',
        display: 'block',
        position: 'absolute',
        transform: 'rotate(3deg) translate(0px, -4px)',
        boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 5px ${theme.palette.primary.main}`
      }
    }
  }
}));






function RouteProgress(props) {


  
  nprogressStyle();

  NProgress.configure({
    speed: 500,
    showSpinner: false
  });

  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return <Route {...props} />;
}

export function RenderRoutes(props) {
  
  
	let routes = [];
  	({routes=[]} = props);

	const profile = useContext(ProfileContext);
	const brand = useContext(BrandContext);
	const selectorContext = useContext(SelectorContext);
	

	if(profile.isLoading && !profile.hasFailed){
		return <LoadingScreen />;
	}
	if(brand.isLoading && !brand.hasFailed){
		return <LoadingScreen />;
	}

	if(routes.length === 0){
		routes = getRoutes(profile,brand,selectorContext);
	}

	return (

		<Suspense fallback={<LoadingScreen />}>
		<Switch>
			{routes.map((route, i) => {
			const Component = route.component;
			const Guard = route.guard || Fragment;
			const Layout = route.layout || Fragment;
			return (
				<RouteProgress
				key={i}
				path={route.path}
				exact={route.exact}
				render={(props) => (
						<Guard>
							<Layout>
								{route.routes ? (
									<RenderRoutes routes={route.routes}/>
								) : (
									<Component {...props} />
								)}
							</Layout>
						</Guard>
				)}
				/>
			);
			})}
		</Switch>
		</Suspense>
	);
}

const getRoutes = (profile,brand,selectorContext) => {
	
	const {
		beans=[]
	} =  profile;
	
	const {
		brand:{
			mode=''
		}
	} = brand;


	let modeSpecificRoutes = [];
	
	switch (mode) {
		case 'rootAdmin':
			modeSpecificRoutes = getRootAdminRoutes(profile,brand);
			break;
		case 'schoolAdmin':
			modeSpecificRoutes = getSchoolRoutes(profile,brand);
			break;
		case 'travelCo':
			modeSpecificRoutes = getTravelCoRoutes(profile,brand,selectorContext);
			break;
		case 'fpCo':
			modeSpecificRoutes = getFPCoRoutes(profile,brand,selectorContext);
			break;
		default: 
			break;
	}

	const authenticatedRoutes = {
		path: '*',
		guard: AuthGuard,
		layout: DashboardLayout,
		routes: [...modeSpecificRoutes,...CommonRoutes]
	};


	const routes = [...UnauthenticatedRoutes,authenticatedRoutes];

	


	// routes.push(CommonRoutes);
	// console.log(routes);
	return routes;

}
